'use client'

import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import Link from 'next/link';

export default function Pagamento() {
  return (
    <main className="min-h-screen flex flex-col">
      <Navbar />
      
      {/* Hero Section */}
      <section className="pt-24 pb-16 bg-teal-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl font-bold text-gray-900 mb-6">Pagamento</h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Escolha a forma de pagamento mais conveniente para você.
            </p>
          </div>
        </div>
      </section>
      
      {/* Payment Options Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto">
            <div className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-200 mb-8">
              <div className="p-6 bg-teal-50 border-b border-gray-200">
                <h2 className="text-2xl font-bold text-gray-900">Resumo do Pedido</h2>
              </div>
              <div className="p-6">
                <div className="flex justify-between mb-4">
                  <span className="text-gray-600">Pacote Premium</span>
                  <span className="font-semibold">€600,00</span>
                </div>
                <div className="flex justify-between mb-4 pb-4 border-b border-gray-200">
                  <span className="text-gray-600">10 sessões de fisioterapia (€60 por sessão)</span>
                  <span className="text-green-600 font-semibold">Economia de €100</span>
                </div>
                <div className="flex justify-between text-lg font-bold">
                  <span>Total</span>
                  <span>€600,00</span>
                </div>
              </div>
            </div>
            
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Escolha a forma de pagamento</h2>
            
            <div className="space-y-4 mb-8">
              <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
                <label className="flex items-center p-4 cursor-pointer">
                  <input type="radio" name="payment-method" className="h-5 w-5 text-teal-600" defaultChecked />
                  <div className="ml-3 flex-1">
                    <span className="font-medium text-gray-900">Cartão de Crédito/Débito</span>
                  </div>
                  <div className="flex space-x-2">
                    <div className="h-8 w-12 bg-gray-200 rounded"></div>
                    <div className="h-8 w-12 bg-gray-200 rounded"></div>
                    <div className="h-8 w-12 bg-gray-200 rounded"></div>
                    <div className="h-8 w-12 bg-gray-200 rounded"></div>
                  </div>
                </label>
                <div className="p-4 border-t border-gray-200 bg-gray-50">
                  <div className="grid grid-cols-2 gap-4 mb-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Nome no cartão</label>
                      <input type="text" className="w-full p-2 border border-gray-300 rounded-md" placeholder="Nome completo" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Número do cartão</label>
                      <input type="text" className="w-full p-2 border border-gray-300 rounded-md" placeholder="1234 5678 9012 3456" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Data de validade</label>
                      <input type="text" className="w-full p-2 border border-gray-300 rounded-md" placeholder="MM/AA" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">CVV</label>
                      <input type="text" className="w-full p-2 border border-gray-300 rounded-md" placeholder="123" />
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
                <label className="flex items-center p-4 cursor-pointer">
                  <input type="radio" name="payment-method" className="h-5 w-5 text-teal-600" />
                  <div className="ml-3 flex-1">
                    <span className="font-medium text-gray-900">Multibanco</span>
                  </div>
                  <div className="h-8 w-12 bg-gray-200 rounded"></div>
                </label>
                <div className="p-4 border-t border-gray-200 bg-gray-50 hidden">
                  <p className="text-gray-600 mb-4">
                    Ao selecionar esta opção, você receberá uma referência Multibanco para efetuar o pagamento.
                  </p>
                </div>
              </div>
              
              <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
                <label className="flex items-center p-4 cursor-pointer">
                  <input type="radio" name="payment-method" className="h-5 w-5 text-teal-600" />
                  <div className="ml-3 flex-1">
                    <span className="font-medium text-gray-900">MBWay</span>
                  </div>
                  <div className="h-8 w-12 bg-gray-200 rounded"></div>
                </label>
                <div className="p-4 border-t border-gray-200 bg-gray-50 hidden">
                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Número de telemóvel</label>
                    <input type="text" className="w-full p-2 border border-gray-300 rounded-md" placeholder="9xx xxx xxx" />
                  </div>
                </div>
              </div>
              
              <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
                <label className="flex items-center p-4 cursor-pointer">
                  <input type="radio" name="payment-method" className="h-5 w-5 text-teal-600" />
                  <div className="ml-3 flex-1">
                    <span className="font-medium text-gray-900">Transferência Bancária</span>
                  </div>
                  <div className="h-8 w-12 bg-gray-200 rounded"></div>
                </label>
                <div className="p-4 border-t border-gray-200 bg-gray-50 hidden">
                  <p className="text-gray-600 mb-4">
                    Ao selecionar esta opção, você receberá os dados bancários para efetuar a transferência.
                  </p>
                </div>
              </div>
            </div>
            
            <div className="flex flex-col space-y-4">
              <button className="w-full py-3 bg-teal-600 hover:bg-teal-700 text-white font-medium rounded-md transition-colors duration-300">
                Finalizar Pagamento
              </button>
              <p className="text-sm text-gray-500 text-center">
                Ao finalizar o pagamento, você concorda com nossos <a href="#" className="text-teal-600 hover:underline">Termos de Serviço</a> e <a href="#" className="text-teal-600 hover:underline">Política de Privacidade</a>.
              </p>
            </div>
          </div>
        </div>
      </section>
      
      {/* FAQ Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Perguntas Frequentes</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Respostas para as dúvidas mais comuns sobre pagamentos.
            </p>
          </div>
          
          <div className="max-w-3xl mx-auto">
            <div className="space-y-6">
              <div className="bg-white p-6 rounded-lg shadow-md">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">Os pacotes têm validade?</h3>
                <p className="text-gray-600">
                  Sim, o Pacote Básico tem validade de 2 meses, o Pacote Premium de 4 meses e o Pacote Família de 6 meses a partir da data de compra.
                </p>
              </div>
              
              <div className="bg-white p-6 rounded-lg shadow-md">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">Posso transferir sessões do meu pacote para outra pessoa?</h3>
                <p className="text-gray-600">
                  O Pacote Família permite a transferência de sessões entre familiares. Os pacotes Básico e Premium são pessoais e intransferíveis.
                </p>
              </div>
              
              <div className="bg-white p-6 rounded-lg shadow-md">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">Posso solicitar reembolso de um pacote?</h3>
                <p className="text-gray-600">
                  Reembolsos podem ser solicitados em até 7 dias após a compra, desde que nenhuma sessão tenha sido utilizada. Após este período ou após a utilização de qualquer sessão, não é possível solicitar reembolso.
                </p>
              </div>
              
              <div className="bg-white p-6 rounded-lg shadow-md">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">Como faço para agendar as sessões após a compra do pacote?</h3>
                <p className="text-gray-600">
                  Após a confirmação do pagamento, você receberá um código de acesso que permitirá agendar suas sessões através do nosso sistema de agendamento online.
                </p>
              </div>
              
              <div className="bg-white p-6 rounded-lg shadow-md">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">Os pagamentos são seguros?</h3>
                <p className="text-gray-600">
                  Sim, utilizamos o Stripe como processador de pagamentos, garantindo a segurança de todas as transações. Seus dados de pagamento são criptografados e não são armazenados em nossos servidores.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </main>
  );
}
